// Enum representing any restrictions posed by customs
export enum CustomsRestrictionType {
  None,
  Other,
  Quarantine,
  SanitaryPhytosanitaryInspection
}
